import regex from "../constants/regex";

export const folderNameIsValid = (folderName) =>
  regex.invalidFolderCharacters.test(folderName);
